export const REQUIRED_SIGNED_PACS_DOCUMENT_COUNT = 5;

export const PACS_FOUNDATION_DOCUMENTS = Object.freeze([
  { id: "REGISTRATION", title: "Registration Certificate", terms: ["REGISTRATION"] },
  { id: "BYLAWS", title: "Registered Bye-laws", terms: ["BYLAW", "BYE LAW"] },
  {
    id: "FINANCIAL_3Y",
    title: "Last Three-year Financial Statements / Balance Sheets",
    terms: ["FINANCIAL", "BALANCE"],
  },
  {
    id: "AUDIT_3Y",
    title: "Last Three-year Audit Reports and Audit Memos",
    terms: ["AUDIT"],
  },
]);

export const PMC_TECHNICAL_DOCUMENTS = Object.freeze([
  {
    id: "PMC_PRELIMINARY_ESTIMATE",
    title: "PMC Preliminary Estimate for Registrar File",
    shortTitle: "Preliminary Estimate",
    phase: "REGISTRAR_FILE",
    requiredForRegistrar: true,
    requiredForSubsidy: false,
  },
  {
    id: "SURVEY_REPORT",
    title: "Site Survey Report",
    shortTitle: "Survey",
    phase: "POST_WORK_START",
    requiredForRegistrar: false,
    requiredForSubsidy: true,
  },
  {
    id: "SOIL_TEST_REPORT",
    title: "Soil Test / Geotechnical Report",
    shortTitle: "Soil Test",
    phase: "POST_WORK_START",
    requiredForRegistrar: false,
    requiredForSubsidy: true,
  },
  {
    id: "DESIGN_DRAWINGS",
    title: "Approved Design and Certified Drawings",
    shortTitle: "Design",
    phase: "POST_WORK_START",
    requiredForRegistrar: false,
    requiredForSubsidy: true,
  },
  {
    id: "FINAL_ESTIMATE",
    title: "Final Technical Estimate",
    shortTitle: "Estimate",
    phase: "POST_WORK_START",
    requiredForRegistrar: false,
    requiredForSubsidy: true,
  },
  {
    id: "DPR",
    title: "Final Detailed Project Report (DPR)",
    shortTitle: "DPR",
    phase: "POST_WORK_START",
    requiredForRegistrar: false,
    requiredForSubsidy: true,
  },
]);

export const REGISTRAR_AUTHORITY_ROLES = Object.freeze([
  "DISTRICT_REGISTRAR",
  "STATE_REGISTRAR",
  "STATE_BRANCH",
  "HEAD_OFFICE",
  "PMC",
  "PACS",
]);

export const technicalDocumentRecord = (project = {}, type) => {
  const map = project.pmcTechnicalDocuments || {};
  if (map[type]?.url) return map[type];
  const aliases = {
    PMC_PRELIMINARY_ESTIMATE: [project.preliminaryEstimate, project.pmcEstimate],
    SURVEY_REPORT: [project.surveyReport, project.finalSurveyReport],
    SOIL_TEST_REPORT: [project.soilTestReport, project.geotechnicalReport],
    DESIGN_DRAWINGS: [project.designDrawings, project.approvedDrawings],
    FINAL_ESTIMATE: [project.finalEstimate, project.technicalEstimate],
    DPR: [project.finalDpr, project.publishedDpr],
  };
  return (aliases[type] || []).find((item) => item?.url) || null;
};

export const technicalDocumentState = (project = {}) =>
  PMC_TECHNICAL_DOCUMENTS.map((item) => ({
    ...item,
    record: technicalDocumentRecord(project, item.id),
    available: Boolean(technicalDocumentRecord(project, item.id)?.url),
  }));

